<script setup lang="ts">
import NewsList from '@features/news/components/NewsList/NewsList.vue'

import { NEWS_LIST_SEO } from '@features/news/constants'
import { createSeoHead } from '@shared/nuxt/createSeoHead'

const route = useRoute()
const { $host } = useNuxtApp()

const { title, description } = NEWS_LIST_SEO

useHead({
  title,
  ...createSeoHead(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="news-page">
    <h1 class="news-page__title">Новости</h1>

    <news-list />
  </div>
</template>

<style lang="scss" scoped>
.news-page {
  padding: 0 20px;
  padding-top: 45px;

  &__title {
    margin-bottom: 40px;
    font-size: 24px;
    font-weight: 800;
    color: var(--ui-color-supporting-01);
  }

  @include media($bp-tablet) {
    padding: 0 48px;
    padding-top: 80px;

    &__title {
      font-size: 40px;
    }
  }

  @include media($bp-desktop-mini) {
    padding: 0;
    padding-top: 40px;
  }
}
</style>
